<script setup lang="ts">
import { inject } from 'vue'
import FacetGroup from './FacetGroup.vue'
import SearchInput from './SearchListSidebarSearchInput.vue'

const { facets, store } = inject('search') as any
</script>

<template>
  <div class="col-12 lg:col-3">
    <aside
      class="flex flex-column p-4"
      style="min-height: 65vh"
    >
      <span class="text-3xl font-light text-400 mb-4">
        Filtering
      </span>
      <search-input />
      <div
        v-if="Object.keys(store.currentFacets).length"
        class="border-1 border-300 border-round my-2"
      >
        <div class="bg-blue-50 border-round-top p-2 flex align-items-center justify-content-between">
          <span class="font-bold uppercase  text-primary-800">
            Selected Filters
          </span>
          <p-btn
            class="p-button-sm p-button-text text-sm py-1 px-2"
            label="Clear All"
            @click="store.clearCurrentFacets()"
          />
        </div>
        <div class="p-1">
          <p-btn
            v-for="{ key, value } in store.selectedFilters"
            :key="`${key}-${value}`"
            class="p-button-sm p-button-outlined px-2 py-2 text-xs m-1"
            @click="store.updateCurrentFacets({ key, value })"
          >
            {{ value }}
            <fa-icon
              icon="fa-solid fa-times"
              class="ml-1 text-base"
            />
          </p-btn>
        </div>
      </div>
      <facet-group
        v-for="(facet, idx) in store.tsResultsFacets.facet_counts"
        :key="facet.field_name"
        :idx="idx"
        :facet="facet"
        :facets-typesense="facets"
        :store="store"
      />
    </aside>
  </div>
</template>
